/* eslint-disable */
import * as Types from './types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type GetChCollectionHandlesQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
  preview?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type GetChCollectionHandlesQuery = { __typename?: 'Query', en?: { __typename?: 'Collection', handle?: string | null } | null, de?: { __typename?: 'Collection', handle?: string | null } | null, fr?: { __typename?: 'Collection', handle?: string | null } | null, it?: { __typename?: 'Collection', handle?: string | null } | null };

export declare const getChCollectionHandles: import("graphql").DocumentNode;

export const GetChCollectionHandlesDocument = /*#__PURE__*/ `
    query getChCollectionHandles($id: String!, $preview: Boolean = false) {
  en: collection(id: $id, locale: "en-CH", preview: $preview) {
    handle
  }
  de: collection(id: $id, locale: "de-CH", preview: $preview) {
    handle
  }
  fr: collection(id: $id, locale: "fr-CH", preview: $preview) {
    handle
  }
  it: collection(id: $id, locale: "it-CH", preview: $preview) {
    handle
  }
}
    `;
export const useGetChCollectionHandlesQuery = <
      TData = GetChCollectionHandlesQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetChCollectionHandlesQueryVariables,
      options?: UseQueryOptions<GetChCollectionHandlesQuery, TError, TData>
    ) =>
    useQuery<GetChCollectionHandlesQuery, TError, TData>(
      ['getChCollectionHandles', variables],
      fetcher<GetChCollectionHandlesQuery, GetChCollectionHandlesQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetChCollectionHandlesDocument, variables, options),
      options
    );

useGetChCollectionHandlesQuery.getKey = (variables: GetChCollectionHandlesQueryVariables) => ['getChCollectionHandles', variables];
;

useGetChCollectionHandlesQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: GetChCollectionHandlesQueryVariables, options?: RequestInit['headers']) => fetcher<GetChCollectionHandlesQuery, GetChCollectionHandlesQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetChCollectionHandlesDocument, variables, options);